// ReportTypeBadge — type badge for reports with icon and color
interface Props {
  type: string;
}

const typeConfig: Record<string, { bg: string; text: string; icon: string }> = {
  "Técnico": { bg: "bg-accent-100 text-accent-700", text: "text-accent-700", icon: "ri-file-list-3-line" },
  "Executivo": { bg: "bg-secondary-100 text-secondary-700", text: "text-secondary-700", icon: "ri-government-line" },
  "Fotográfico": { bg: "bg-fuchsia-100 text-fuchsia-700", text: "text-fuchsia-700", icon: "ri-camera-line" },
  "Cartográfico/GIS": { bg: "bg-sky-100 text-sky-700", text: "text-sky-700", icon: "ri-map-2-line" },
  "Inventário arbóreo": { bg: "bg-primary-100 text-primary-700", text: "text-primary-700", icon: "ri-tree-line" },
  "FCA individual": { bg: "bg-primary-100 text-primary-700", text: "text-primary-700", icon: "ri-file-text-line" },
  "Árvores de risco": { bg: "bg-red-100 text-red-700", text: "text-red-700", icon: "ri-alert-line" },
  "Manejo recomendado": { bg: "bg-orange-100 text-orange-700", text: "text-orange-700", icon: "ri-scissors-line" },
  "Espécies": { bg: "bg-green-100 text-green-700", text: "text-green-700", icon: "ri-leaf-line" },
  "Bairro/logradouro": { bg: "bg-accent-100 text-accent-700", text: "text-accent-700", icon: "ri-map-pin-line" },
  "Área verde": { bg: "bg-emerald-100 text-emerald-700", text: "text-emerald-700", icon: "ri-landscape-line" },
  "Unidade de Conservação": { bg: "bg-emerald-100 text-emerald-700", text: "text-emerald-700", icon: "ri-shield-star-line" },
  "Carbono": { bg: "bg-teal-100 text-teal-700", text: "text-teal-700", icon: "ri-cloud-line" },
  "Compensação ambiental": { bg: "bg-lime-100 text-lime-700", text: "text-lime-700", icon: "ri-plant-line" },
  "Documental": { bg: "bg-secondary-100 text-secondary-700", text: "text-secondary-700", icon: "ri-folder-line" },
  "RRR / Governança": { bg: "bg-indigo-100 text-indigo-700", text: "text-indigo-700", icon: "ri-shield-check-line" },
  "Auditoria": { bg: "bg-amber-100 text-amber-700", text: "text-amber-700", icon: "ri-search-line" },
  "Transparência pública": { bg: "bg-cyan-100 text-cyan-700", text: "text-cyan-700", icon: "ri-eye-line" },
};

export default function ReportTypeBadge({ type }: Props) {
  const c = typeConfig[type] || { bg: "bg-background-100 text-foreground-500", text: "text-foreground-500", icon: "ri-file-line" };
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${c.bg}`}>
      <i className={`${c.icon} w-3 h-3 flex items-center justify-center`} />
      {type}
    </span>
  );
}